<div class="position-absolute backdrop" *ngIf="globalSpinnerService.visible">
  <div class="position-absolute spinner-container" [style.padding-left.rem]="paddingLeft / 16">
    <app-spinner></app-spinner>
  </div>
</div>
